import { useNavigate } from 'react-router-dom'
import { ArrowLeftIcon } from '@heroicons/react/24/outline'

export default function BackButtonAndTitle({ title, navigateTo, onBack }) {
  const navigate = useNavigate()

  const handleBack = () => {
    if (onBack) {
      onBack()
      return
    }

    if (navigateTo) {
      navigate(navigateTo)
      return
    }
    // goBackOrHome()

    navigate(-1)
  }

  return (
    <div className="flex gap-2  items-center my-3 font-semibold">
      <button onClick={handleBack} className="  text-black" aria-label="Go back">
        <ArrowLeftIcon className="w-5 h-5 stroke-2" />
      </button>
      <h1 className="text-xl  text-gray-800">{title}</h1>
    </div>
  )
}
